import React, { createContext, useContext, useState } from "react";

const FormContext = createContext();
export const useFormContext = () => useContext(FormContext);

// 1. Product Search State
const initialFormState = {
  Molecule: {
    ATCClass: null,
    DosageForm: null,
    RouteOfAdministration: null,
  },
  dates: {
    Before: "",
    US: "",
  },
  checkboxes: {
    Curated: false,
    SupplyWithSupply: false,
    SupplyTechTransfer: false,
  },
  ManufacturingFacilityLocation: [],
  DossierReadiness: [],
  RegionofInterest: [],
  supplyArray: { withSupply: false, techTransfer: false },
};

// 2. Supplier Filter State
const initialSupplierState = {
  ManufacturingPlantLocation: [],
  DosageForms: [],
  cGMPAccreditation: [],
  Specialcapabilities: [],
  ManufacturerType: [],
  operation: {
    fiveless: false,
    sixtoten: false,
    tentotwenty: false,
    Twentymore: false,
  },
};

export const FormProvider = ({ children }) => {
  const [formState, setFormState] = useState(initialFormState);
  const [supplierFormState, setSupplierFormState] =
    useState(initialSupplierState);
  const [search, setSearch] = useState("");
  const [supsearch, setSupSearch] = useState("");
  const [dossierViewMode, setDossierViewMode] = useState("cards");
  return (
    <FormContext.Provider
      value={{
        formState,
        setFormState,
        supplierFormState,
        setSupplierFormState,
        search,
        setSearch,
        supsearch,
        setSupSearch,
        dossierViewMode,
        setDossierViewMode,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};
